import { Link } from "react-router-dom"

import Button from "../../components/shared-components/Button"
import bigLaptop from "../../assets/images/bigLaptop.png"
import smallLaptop from "../../assets/images/smallLaptop.png"
import useQuote from "../../components/shared-components/getQuote/useQuote"
import { placeholder } from "../../util/placeholder"
import { useSelector } from "react-redux"
import Nav from "./Nav"
import { useEffect, useState } from "react"
import {
  BlogDetails,
  CardDetails,
  CardTwoDetails,
  ourDetails,
  socials,
  whatWeDo,
} from "../../components/shared-components/Datas"
import Card from "./Card"
import { formInputs } from "./formInputs"
import cargo_package from "../../assets/images/cargo_package.png"
import ServiceCard from "./ServiceCard"
import {
  landingPathName,
  loginPathName,
} from "../../components/routes/pathName"
import InputField from "../../components/shared-components/Input"
import ScrollToTop from "./ScrollToTop"
import tiktok1 from "../../assets/images/tiktok2.svg"

const Landing = () => {
  const {
    values,
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    errors,
    touched,
    isSubmitting,
  } = useQuote()
  const { airports } = useSelector((state) => state.airports)

  const [bgImage, setBgImage] = useState(bigLaptop)

  function handleResize() {
    if (window.innerWidth < 760) {
      setBgImage(smallLaptop)
    } else {
      setBgImage(bigLaptop)
    }
  }

  useEffect(() => {
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return (
    <>
      <div>
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-y-4 bg-[#0E94CD] text-white px-[1.25rem] xl:px-20 py-3 sm:py-6 font-montserrat ">
          <div className="flex gap-5 items-center">
            {socials.map((data) => (
              <Link key={data.id} to={data.link} target="_blank">
                <img src={data.icon} alt="" />
              </Link>
            ))}
          </div>
          <p className="">
            71A, Oduduwa Crescent, GRA, Ikeja, Lagos. | +2349123167602 |
            +2348089887115 | info@logistifly.com
          </p>
        </div>
        <div
          className="px-[1.25rem] xl:px-20 bg-[#2C2C2C] text-white w-full h-screen bg-position-x-[21rem] bg-no-repeat  bg-[4rem_23rem] md:bg-[-4rem_15rem] lg:bg-[21rem_10rem] "
          style={{
            backgroundImage: `url('${bgImage}')`,
          }}
        >
          <div className="pt-8 relative">
            <Nav />
          </div>

          <div className="w-[22rem] md:w-[35rem] pt-5 lg:pt-24 space-y-[1rem] md:space-y-[1.5rem] text-center md:text-start">
            <h2 className="text-[3rem] lg:text-[4.5rem]  font-bold leading-[3rem] lg:leading-[5rem] ">
              Send and receive parcels{" "}
              <span className="font-playfair italic">seamlessly</span>
            </h2>
            <p className="text-[1.25rem] lg:text-[1.5rem] font-normal font-gothic ">
              Redefining Global Air Freight Logistics – Powered by Technology.
            </p>
            <div className="w-[20rem] ">
              <Link to={loginPathName}>
                <Button text={"Get started"} className="!w-full" />
              </Link>
            </div>
          </div>
        </div>
        <div
          className="w-full md:h-[40vh] flex justify-center relative py-[3rem]"
          id="get-quote"
        >
          <div className="flex flex-col md:flex-row items-center justify-between gap-y-[1.25rem] bg-[#EFFAFF] w-[90%] lg:w-[80%] static md:absolute -top-24 rounded-t-[1.25rem] px-[1rem] lg:px-[3rem] py-[1rem] lg:py-[2rem] ">
            <div className="w-[15.5rem] lg:w-[17rem] text-center md:text-start ">
              <h3 className="text-[2rem] font-medium font-montserrat ">
                Get Instant Online Quotes!
              </h3>
              <p className="text-[#2C2C2C] ">
                Experience seamless shipping with Shippfy. Enjoy the convenience
                of instant freight quotes online
              </p>
            </div>
            <div className="w-full md:w-[70%] lg:w-[60%] ">
              <form onSubmit={handleSubmit}>
                <div className="grid md:grid-cols-2 gap-6">
                  {Object.entries(values).map(([key, value], index) => (
                    <div
                      key={index}
                      className="flex-col bg-white rounded-[0.3rem] px-4 "
                    >
                      {/* <label className="">{placeholder(key)}</label> */}
                      {formInputs(
                        key,
                        airports,
                        value,
                        handleChange,
                        placeholder,
                        setFieldValue,
                        handleBlur,
                        errors,
                        touched
                      )}
                    </div>
                  ))}
                  <Button
                    disabled={
                      values.departure === "" ||
                      values.destination === "" ||
                      isSubmitting
                    }
                    isLoading={isSubmitting}
                    type="submit"
                    text="Get Quote"
                    className={"!text-white"}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="px-[1.25rem] xl:px-20 py-6" id="about">
          <div className="xl:w-[78%] mx-auto text-center ">
            <h4 className="text-[1.5rem] xl:text-[2rem] font-medium font-montserrat ">
              WHY CHOOSE LOGISTIFLY
            </h4>
            <p className="xl:text-[1.2rem] font-gothic">
              Logistifly brings a fresh perspective to air freight logistics by
              combining cutting-edge technology with unmatched reliability.
              Whether you’re shipping a single package or managing complex
              freight operations, our platform is designed to make every step
              simple, transparent, and efficient.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap xl:flex-nowrap justify-center itesms-center gap-[1.3rem] px-[1.25rem] xl:px-20 py-6">
          {CardTwoDetails.map((data, i) => (
            <Card
              key={i}
              {...data}
              className={"bg-[#effaff] "}
              titleClassName={"!font-bold"}
              contentClassName={"!text-[0.85rem] "}
            />
          ))}
        </div>

        <div className="flex flex-wrap xl:flex-nowrap justify-center itesms-center gap-[1.3rem] px-[1.25rem] xl:px-20 py-6">
          {CardDetails.map((data, i) => (
            <Card key={i} {...data} />
          ))}
        </div>

        <div className="flex justify-center py-[3rem] ">
          <div className="relative flex flex-col md:flex-row items-center justify-between gap-y-[1.25rem] bg-[#EFFAFF] w-[90%] lg:w-[80%] rounded-[1.25rem] px-[1rem] lg:px-[3rem] py-[1rem] lg:py-[2rem]">
            <div className="w-full md:w-[40%] xl:w-[30%] text-[#2C2C2C] order-2 md:order-1 ">
              <h5 className="text-[2rem] font-medium leading-[123%] ">
                Premium logistics in a class of it’s own
              </h5>
              <p className="mt-[1.1rem] ">
                We’re truly dedicated to serving the global trade with a
                permanent endeavor to conserve energy, protect people and
                preserve the environment thereby contributing towards global
                economic growth and development.
              </p>
              <div className="mt-[2.5rem] ">
                <Link to={loginPathName}>
                  <Button text={"Get started"} className={"!text-white"} />
                </Link>
              </div>
            </div>
            <div className="w-full md:w-[65%] static md:absolute top-[-3rem] lg:top-[-5rem] right-0 order-1 md:order-2 ">
              <img src={cargo_package} alt="cargo_package" className="" />
            </div>
          </div>
        </div>

        <div className="w-full px-[1.25rem] xl:px-20 py-8" id="services">
          <h6 className="text-[2rem] text-center font-medium">OUR SERVICES</h6>
          <div className="flex flex-wrap justify-center gap-[1.3rem] mt-[2rem] ">
            {BlogDetails.map((data, i) => (
              <ServiceCard key={i} {...data} />
            ))}
          </div>
        </div>

        <div className="w-full px-[1.25rem] xl:px-20 py-6">
          <h6 className="text-[2rem] text-center font-medium">
            Our Customers Love What We Do
          </h6>
          <div className="flex flex-wrap justify-center gap-[1.3rem] mt-[2rem] ">
            {whatWeDo.map((data, i) => (
              <Card
                key={i}
                {...data}
                iconClassName={"w-[1.5rem] "}
                titleClassName={
                  "!w-[20rem] !text-[1rem] !text-[#2C2C2C]] !font-normal "
                }
                contentClassName={"!w-fit !font-black "}
                className={"!bg-[#f3f4f6] !rounded-[0.5rem] "}
              />
            ))}
          </div>
        </div>

        <div className="px-[1.25rem] xl:px-20 py-6" id="contact">
          <div className="px-8 xl:px-24 py-4 xl:py-12 rounded-[1.25rem] bg-footerBG bg-no-repeat w-full text-white bg-center bg-cover h-fit">
            <div className="flex flex-col lg:flex-row justify-between lg:items-center gap-y-8 ">
              <div className="">
                <Link to={landingPathName}>
                  <h1 className="text-[2rem] sm:text-[3rem] font-playfair font-black italic  ">
                    Logistifly
                  </h1>
                </Link>
                <p className="text-[0.75] w-full  lg:w-[20rem] mt-[1.25rem] ">
                  We pride ourselves on our commitment to excellence. Our
                  extensive network and advanced technology enable us to provide
                  seamless, end-to-end shipping services, ensuring your goods
                  reach their destination safely and on time.
                </p>
              </div>

              <ul className=" grid grid-cols-2  gap-10 ">
                {ourDetails.map((detail, i) => (
                  <li key={i} className="">
                    <a href={detail.link}>{detail.name}</a>
                  </li>
                ))}
              </ul>

              <div className="">
                <div className="">
                  <p className="text-[2rem] font-medium ">Stay updated!</p>
                  <p className="mt-[0.3rem] ">
                    Get first-hand updates when we release them
                  </p>
                </div>
                <form className="mt-[1.5rem] ">
                  <InputField placeholder="Email" className={"!pt-[1.5rem] "} />
                  <div className="mt-[1.2rem] ">
                    <Button text={"Subscribe"} />
                  </div>
                </form>
              </div>
            </div>
            <div className="flex gap-5 items-center mt-[3rem] ">
              {socials.map((data) => (
                <Link key={data.id} to={data.link} target="_blank">
                  <img src={data.id === 4 ? tiktok1 : data.icon} alt="" />
                </Link>
              ))}
            </div>
          </div>
          <p className=" text-center w-full mt-[1.25rem] ">
            COPYRIGHT &copy; {new Date().getFullYear()} ALL RIGHTS RESERVED BY
            LOGISTIFLY
          </p>
        </div>
      </div>
      <ScrollToTop />
    </>
  )
}

export default Landing
